<template>
  <footer class="footer">
    <div class="footer--whitelabel">
      <a
        class="footer-text"
        href="https://www.ringba.com/"
        target="_BLANK"
      >Powered by Ringba</a>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style>
</style>